import React from "react";
import PropTypes from "prop-types";

const initials = (name) =>
  (name || "").trim().split(/\s+/).slice(0, 2).map((word) => word[0]).join("").toUpperCase();

const RosterCard = ({ artist, removeControl }) => (
  <div className="roster-card">
    <a className="roster-card-media" href={artist.path}>
      {artist.imageUrl ? (
        <img src={artist.imageUrl} alt={artist.name} />
      ) : (
        <span className="roster-card-initials">{initials(artist.name)}</span>
      )}
      {artist.onTour && <span className="roster-card-tag">On tour</span>}
    </a>
    {removeControl}
    <div className="roster-card-body">
      <a className="roster-card-name" href={artist.path}>{artist.name}</a>
      <span className="roster-card-genre">{artist.genre || "—"}</span>
      <dl className="roster-card-stats">
        <dt>Last played</dt>
        <dd>{artist.lastPlayed || "Never"}</dd>
        <dt>Shows with you</dt>
        <dd>{artist.shows}</dd>
        <dt>Avg Tix Sold</dt>
        <dd>{artist.avgTicketsSold == null ? "—" : artist.avgTicketsSold.toLocaleString()}</dd>
      </dl>
    </div>
  </div>
);

RosterCard.propTypes = {
  artist: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string,
    imageUrl: PropTypes.string,
    genre: PropTypes.string,
    onTour: PropTypes.bool,
    shows: PropTypes.number,
    lastPlayed: PropTypes.string,
    avgTicketsSold: PropTypes.number,
  }).isRequired,
  removeControl: PropTypes.node,
};

RosterCard.defaultProps = { removeControl: null };

export default RosterCard;
